<template>
  <b-row align-h="center">
    <div cols="12" class="w-75">
      <FITModal :title="$t('crm.customer.create.header')" reference="customerConfirmationModal" ref="confirmation" @click="confirm">
        <div slot="body">
          {{ $t('adm.agent.confirmation') }}
        </div>
      </FITModal>
      <FITFormCard v-if="ID !== null">
        <div slot="header">
          <span class="h5"><span class="fa fa-school mr-2"></span>{{ $t('adm.cpd.header') }}</span>
        </div>
        <div slot="formBody">
          <b-row>
            <b-col cols="6">
              <FITDatePicker v-model="cpdForm.startDate" :label="$t('general.startDate')" :placeholder="$t('general.startDate')" :width="10"></FITDatePicker>
            </b-col>
            <b-col cols="6">
              <FITDatePicker v-model="cpdForm.endDate" :label="$t('general.endDate')" :placeholder="$t('general.endDate')" :width="10"></FITDatePicker>
            </b-col>
          </b-row>
          <b-row class="mt-1 py-2">
            <b-col cols="4">
              <span>{{ $t('adm.cpd.list.corePoints') }}: </span>
              <span>{{ cpdPoints.corePoints }}</span>
            </b-col>
            <b-col cols="4">
              <span>{{ $t('adm.cpd.list.nonCorePoints') }}: </span>
              <span>{{ cpdPoints.nonCorePoints }}</span>
            </b-col>
            <b-col cols="4">
              <span>{{ $t('adm.cpd.list.totalPoints') }}: </span>
              <span>{{ cpdPoints.totalPoints }}</span>
            </b-col>
          </b-row>
        </div>
      </FITFormCard>
      <FITFormCard>
        <div slot="header">
          <b-row align-v="center">
            <b-col cols="8">
              <p class="h5"><i class="fa fa-id-card mr-2"></i>{{ $t('crm.customer.create.personalHeader') }}</p>
            </b-col>
            <b-col cols="4" class="text-right">
              <span class="h5" @click="updateLocked" v-if="ID !== null">
                <i style="cursor: pointer" :class="{ 'fa' : true, 'fa-lock' : locked, 'fa-unlock' : !locked }"></i>
              </span>
            </b-col>
          </b-row>
        </div>
        <div slot="formBody">
          <b-row>
            <b-col cols="6">
              <FITTextInput field="englishLastname" :label="$t('crm.customer.create.englishLastname')" :placeholder="
            $t('crm.customer.create.englishLastname')" v-model="form.englishLastname" :width="columnWidth" :disabled="locked"></FITTextInput>
              <FITTextInput field="chineseFirstname" :label="$t('crm.customer.create.chineseFirstname')" :placeholder="$t('crm.customer.create.chineseFirstname')" v-model="form.chineseFirstname" :width="columnWidth" :disabled="locked"></FITTextInput>
              <FITTextInput :label="$t('crm.customer.create.identityCardNo')" :placeholder="$t('crm.customer.create.identityCardNo')" v-model="form.identityCardNo" :width="columnWidth" :disabled="locked"></FITTextInput>
              <FITDatePicker :label="$t('crm.customer.create.dateOfBirth')" :placeholder="$t('crm.customer.create.dateOfBirth')" v-model="form.dateOfBirth" :width="columnWidth" :disabled="locked"></FITDatePicker>
            </b-col>
            <b-col cols="6">
              <FITTextInput field="englishFirstname" :label="$t('crm.customer.create.englishFirstname')" :placeholder="
            $t('crm.customer.create.englishFirstname')" v-model="form.englishFirstname" :width="columnWidth" :disabled="locked"></FITTextInput>
              <!-- <FITTextInput field="chineseLastname" :label="$t('crm.customer.create.chineseLastname')" :placeholder="$t('crm.customer.create.chineseLastname')" v-model="form.chineseLastname" :width="columnWidth" :disabled="locked"></FITTextInput> -->
              <FITSelect :label="$t('crm.customer.create.idType')" :placeholder="$t('crm.customer.create.idType')" :options="idTypes" v-model="form.idType" :width="columnWidth" :disabled="locked"></FITSelect>
              <FITSelect :label="$t('crm.customer.create.gender')" :placeholder="$t('crm.customer.create.gender')" :options="genders" v-model="form.gender" :width="columnWidth" :disabled="locked"></FITSelect>
              <FITSelect :label="$t('crm.customer.create.maritalStatus')" :placeholder="$t('crm.customer.create.maritalStatus')" :options="maritalStatus" v-model="form.maritalStatus" :width="columnWidth" :disabled="locked"></FITSelect>
              <!--               <FITSelect :label="$t('crm.customer.create.contactType')" :placeholder="$t('crm.customer.create.contactType')" :options="contactTypes" v-model="form.contactType" :width="columnWidth" :disabled="locked"></FITSelect>
 -->
            </b-col>
            <!--             
            <b-col cols="12">
              <FITTextarea :label="$t('crm.customer.create.defaultAddress')" :placeholder="$t('crm.customer.create.defaultAddress')" v-model="form.defaultAddress" :width="10" :disabled="locked"></FITTextarea>
            </b-col> 
            -->
          </b-row>
        </div>
      </FITFormCard>
      <FITFormCard>
        <div slot="header">
          <b-row>
            <b-col cols="8">
              <p class="h5"><i class="fa fa-phone-square mr-2"></i>{{ $t('crm.customer.create.contactHeader') }}</p>
            </b-col>
            <b-col cols="4" class="text-right">
            </b-col>
          </b-row>
        </div>
        <div slot="formBody">
          <b-row>
            <b-col cols="6">
              <FITTextInput :label="$t('crm.customer.create.telephoneMobile')" :placeholder="
            $t('crm.customer.create.telephoneMobile')" v-model="form.telephoneMobile" :width="columnWidth" :disabled="locked"></FITTextInput>
              <FITTextInput :label="$t('crm.customer.create.telephoneHome')" :placeholder="$t('crm.customer.create.telephoneHome')" v-model="form.telephoneHome" :width="columnWidth" :disabled="locked"></FITTextInput>
            </b-col>
            <b-col cols="6">
              <FITTextInput :label="$t('crm.customer.create.telephoneOffice')" :placeholder="$t('crm.customer.create.telephoneOffice')" v-model="form.telephoneOffice" :width="columnWidth" :disabled="locked"></FITTextInput>
              <!-- <FITTextInput :label="$t('crm.customer.create.fax')" :placeholder="$t('crm.customer.create.fax')" v-model="form.fax" :width="columnWidth" :disabled="locked"></FITTextInput> -->
              <!-- <FITTextInput :label="$t('crm.customer.create.email')" :placeholder="
            $t('crm.customer.create.email')" v-model="form.userEmail" :width="columnWidth" :disabled="true"></FITTextInput> -->
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col cols="12" class="my-3">
                  <span class="h5">
                  {{$t('crm.customer.create.residentialAddress')}}
                </span>
                  <b-row class="pt-2 pb-3">
                    <b-col cols="12">
                      <FITTextarea field="englishResidentialAddress" :label="$t('crm.customer.create.englishResidentialAddress')" :placeholder="$t('crm.customer.create.englishResidentialAddress')" v-model="form.englishResidentialAddress" :width="11" :disabled="locked" alignV="top"></FITTextarea>
                    </b-col>
                    <!--                    <b-col cols="6">
                      <FITTextarea field="chineseResidentialAddress" :label="$t('crm.customer.create.chineseResidentialAddress')" :placeholder="$t('crm.customer.create.chineseResidentialAddress')" v-model="form.chineseResidentialAddress" :width="10" :disabled="locked" alignV="top"></FITTextarea>
                    </b-col>
  -->
                  </b-row>
                  <b-row>
                    <b-col cols="auto">
                      <span class="h5 mr-5">{{$t('crm.customer.create.correspondenceAddress')}}</span>
                      <span class="text-danger">{{$t('crm.customer.create.correspondenceAddressLeaveBlank')}}</span>
                    </b-col>
                  </b-row>
                  <b-row class="pt-2 pb-3">
                    <b-col cols="12">
                      <FITTextarea field="englishCorrespondenceAddress" :label="$t('crm.customer.create.englishCorrespondenceAddress')" :placeholder="$t('crm.customer.create.englishCorrespondenceAddress')" v-model="form.englishCorrespondenceAddress" :width="11" :disabled="locked" alignV="top"></FITTextarea>
                    </b-col>
                    <!--  <b-col cols="6">
                      <FITTextarea field="chineseCorrespondenceAddress" :label="$t('crm.customer.create.chineseCorrespondenceAddress')" :placeholder="$t('crm.customer.create.chineseCorrespondenceAddress')" v-model="form.chineseCorrespondenceAddress" :width="10" :disabled="locked" alignV="top"></FITTextarea>
                    </b-col> -->
                  </b-row>
                  <!--                   <span class="h5">
                  {{$t('crm.customer.create.companyAddress')}}
                </span>
                  <b-row class="pt-2 pb-3">
                    <b-col cols="6">
                      <FITTextarea field="englishCompanyAddress" :label="$t('crm.customer.create.englishCompanyAddress')" :placeholder="$t('crm.customer.create.englishCompanyAddress')" v-model="form.englishCompanyAddress" :width="10" :disabled="locked" alignV="top"></FITTextarea>
                    </b-col>
                    <b-col cols="6">
                      <FITTextarea field="chineseCompanyAddress" :label="$t('crm.customer.create.chineseCompanyAddress')" :placeholder="$t('crm.customer.create.chineseCompanyAddress')" v-model="form.chineseCompanyAddress" :width="10" :disabled="locked" alignV="top"></FITTextarea>
                    </b-col>
                  </b-row> -->
                </b-col>
              </b-row>
              <!-- <span class="h5">
                {{$t('crm.customer.create.residentialAddress')}}
              </span>
              <FITTextarea :label="$t('crm.customer.create.englishResidentialAddress')" :placeholder="$t('crm.customer.create.englishResidentialAddress')" v-model="form.englishResidentialAddress" :width="10" :disabled="locked"></FITTextarea>
              <FITTextarea :label="$t('crm.customer.create.chineseResidentialAddress')" :placeholder="$t('crm.customer.create.chineseResidentialAddress')" v-model="form.chineseResidentialAddress" :width="10" :disabled="locked"></FITTextarea>
              <b-row>
                <b-col cols="4">
                  <span class="h5">
                    {{$t('crm.customer.create.correspondenceAddress')}}
                  </span>
                </b-col>
                <b-col cols="8" class="text-center">
                  <span class="text-danger">{{$t('crm.customer.create.correspondenceAddressLeaveBlank')}}</span>
                </b-col>
              </b-row>
              <FITTextarea :label="$t('crm.customer.create.englishCorrespondenceAddress')" :placeholder="$t('crm.customer.create.englishCorrespondenceAddress')" v-model="form.englishCorrespondenceAddress" :width="10" :disabled="locked"></FITTextarea>
              <FITTextarea :label="$t('crm.customer.create.chineseCorrespondenceAddress')" :placeholder="$t('crm.customer.create.chineseCorrespondenceAddress')" v-model="form.chineseCorrespondenceAddress" :width="10" :disabled="locked"></FITTextarea>
              <span class="h5">
                  {{$t('crm.customer.create.companyAddress')}}
                </span>
              <FITTextarea :label="$t('crm.customer.create.englishCompanyAddress')" :placeholder="$t('crm.customer.create.englishCompanyAddress')" v-model="form.englishCompanyAddress" :width="10" :disabled="locked"></FITTextarea>
              <FITTextarea :label="$t('crm.customer.create.chineseCompanyAddress')" :placeholder="$t('crm.customer.create.chineseCompanyAddress')" v-model="form.chineseCompanyAddress" :width="10" :disabled="locked"></FITTextarea> -->
            </b-col>
          </b-row>
        </div>
      </FITFormCard>
      <FITFormCard>
        <div slot="header">
          <p class="h5"><i class="fa fa-user-circle mr-2"></i>{{ $t('adm.agent.agentInformation') }}</p>
        </div>
        <div slot="formBody">
          <b-row>
            <b-col cols="6">
              <FITTextInput field="agentCode" :label="$t('adm.agent.agentCode')" :placeholder="$t('adm.agent.agentCode')" v-model.trim="form.agentCode" :width="columnWidth" :disabled="locked"></FITTextInput>
              <FITDatePicker :label="$t('adm.agent.joinDate')" v-model="form.joinDate" :placeholder="$t('adm.agent.joinDate')" :width="columnWidth" :disabled="locked"></FITDatePicker>
            </b-col>
            <b-col cols="6">

              <FITSelect :label="$t('adm.agent.position')" :placeholder="$t('adm.agent.position')" :options="positions" v-model.trim="form.position" :width="columnWidth" :disabled="locked"></FITSelect>
              <FITDatePicker :label="$t('adm.agent.leaveDate')" v-model="form.leaveDate" :placeholder="$t('adm.agent.leaveDate')" :width="columnWidth" :disabled="locked"></FITDatePicker>

              
<!--               <b-row align-v="center">
                <b-col cols="9">
                  <FITAutoSearch :label="$t('adm.agent.parentAgent')" dest="agent" :placeholder="$t('adm.agent.parentAgent')" v-model="selectedParentAgent" :paras="[{ key: 'type', value: 'agent' }]" :showItems="['agentCode', 'agentEnglishName', 'agentChineseName']" :width="columnWidth" ref="noParentAgent" :disabled="isParentAgentDisabled || locked"></FITAutoSearch>
                </b-col>
                <b-col cols="3">
                  <b-button size="sm" @click="lockParentAgent" :variant="isParentAgentDisabled ? 'primary' : 'danger'" :disabled="locked"><i :class="{
                    'fa-minus-circle' : !isParentAgentDisabled,
                    'fa-check-circle' : isParentAgentDisabled
                  }" class="fa mr-2"></i>{{ isParentAgentDisabled ? $t('adm.agent.hasParentAgent') : $t('adm.agent.noParentAgent') }}</b-button>
                </b-col>
              </b-row>
              <b-row align-v="center">
                <b-col cols="9">
                  <FITAutoSearch :label="$t('adm.agent.agentTeam')" dest="team" :placeholder="$t('adm.agent.agentTeam')" v-model="selectedAgentTeam" :paras="[{ key: 'type', value: 'team' }]" :showItems="['teamCode']" :width="columnWidth" ref="noAgentTeam" :disabled="isAgentTeamDisabled || locked"></FITAutoSearch>
                </b-col>
                <b-col cols="3">
                  <b-button size="sm" @click="lockAgentTeam" :variant="isAgentTeamDisabled ? 'primary' : 'danger'" :disabled="locked"><i :class="{
                    'fa-minus-circle' : !isAgentTeamDisabled,
                    'fa-check-circle' : isAgentTeamDisabled
                  }" class="fa mr-2"></i>{{ isAgentTeamDisabled ? $t('adm.agent.hasAgentTeam') : $t('adm.agent.noAgentTeam') }}</b-button>
                </b-col>
              </b-row> -->
            </b-col>
          </b-row>
        </div>
      </FITFormCard>
      <FITFormCard>
        <div slot="header">
          <p class="h5"><i class="fa fa-address-book mr-2"></i>{{ $t('adm.agent.license') }}</p>
        </div>
        <div slot="formBody">
          <b-row>
            <b-col cols="6">
              <FITSelect :label="$t('adm.agent.cibLicense')" :placeholder="$t('adm.agent.cibLicense')" :options="yesNo" v-model="form.cibLicense" :width="columnWidth" :disabled="locked"></FITSelect>
            </b-col>
            <b-col cols="6">
              <FITSelect :label="$t('adm.agent.mpfaLicense')" :placeholder="$t('adm.agent.mpfaLicense')" :options="yesNo" v-model="form.mpfaLicense" :width="columnWidth" :disabled="locked"></FITSelect>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <FITSelect :label="$t('adm.agent.ociLicensePrinciples')" :placeholder="$t('adm.agent.ociLicensePrinciples')" :options="yesNo" v-model="form.ociLicensePrinciples" :width="columnWidth" :disabled="locked"></FITSelect>
              <FITSelect :label="$t('adm.agent.ociLicenseGeneral')" :placeholder="$t('adm.agent.ociLicenseGeneral')" :options="yesNo" v-model="form.ociLicenseGeneral" :width="columnWidth" :disabled="locked"></FITSelect>
            </b-col>
            <b-col cols="6">
              <FITSelect :label="$t('adm.agent.ociLicenseLongTerm')" :placeholder="$t('adm.agent.ociLicenseLongTerm')" :options="yesNo" v-model="form.ociLicenseLongTerm" :width="columnWidth" :disabled="locked"></FITSelect>
              <FITSelect :label="$t('adm.agent.ociLicenseLinkedLongTerm')" :placeholder="$t('adm.agent.ociLicenseLinkedLongTerm')" :options="yesNo" v-model="form.ociLicenseLinkedLongTerm" :width="columnWidth" :disabled="locked"></FITSelect>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <FITSelect :label="$t('adm.agent.sfcLicenseType1')" :placeholder="$t('adm.agent.sfcLicenseType1')" :options="yesNo" v-model="form.sfcLicenseType1" :width="columnWidth" :disabled="locked"></FITSelect>
              <FITSelect :label="$t('adm.agent.sfcLicenseType2')" :placeholder="$t('adm.agent.sfcLicenseType2')" :options="yesNo" v-model="form.sfcLicenseType2" :width="columnWidth" :disabled="locked"></FITSelect>
              <FITSelect :label="$t('adm.agent.sfcLicenseType3')" :placeholder="$t('adm.agent.sfcLicenseType3')" :options="yesNo" v-model="form.sfcLicenseType3" :width="columnWidth" :disabled="locked"></FITSelect>
              <FITSelect :label="$t('adm.agent.sfcLicenseType4')" :placeholder="$t('adm.agent.sfcLicenseType4')" :options="yesNo" v-model="form.sfcLicenseType4" :width="columnWidth" :disabled="locked"></FITSelect>
              <FITSelect :label="$t('adm.agent.sfcLicenseType5')" :placeholder="$t('adm.agent.sfcLicenseType5')" :options="yesNo" v-model="form.sfcLicenseType5" :width="columnWidth" :disabled="locked"></FITSelect>
            </b-col>
            <b-col cols="6">
              <FITSelect :label="$t('adm.agent.sfcLicenseType6')" :placeholder="$t('adm.agent.sfcLicenseType6')" :options="yesNo" v-model="form.sfcLicenseType6" :width="columnWidth" :disabled="locked"></FITSelect>
              <FITSelect :label="$t('adm.agent.sfcLicenseType7')" :placeholder="$t('adm.agent.sfcLicenseType7')" :options="yesNo" v-model="form.sfcLicenseType7" :width="columnWidth" :disabled="locked"></FITSelect>
              <FITSelect :label="$t('adm.agent.sfcLicenseType8')" :placeholder="$t('adm.agent.sfcLicenseType8')" :options="yesNo" v-model="form.sfcLicenseType8" :width="columnWidth" :disabled="locked"></FITSelect>
              <FITSelect :label="$t('adm.agent.sfcLicenseType9')" :placeholder="$t('adm.agent.sfcLicenseType9')" :options="yesNo" v-model="form.sfcLicenseType9" :width="columnWidth" :disabled="locked"></FITSelect>
              <FITSelect :label="$t('adm.agent.sfcLicenseType10')" :placeholder="$t('adm.agent.sfcLicenseType10')" :options="yesNo" v-model="form.sfcLicenseType10" :width="columnWidth" :disabled="locked"></FITSelect>
            </b-col>
          </b-row>
        </div>
      </FITFormCard>
      <FITFormCard>
        <div slot="header">
          <b-row>
            <b-col cols="8">
              <p class="h5"><i class="fa fa-id-card mr-2"></i>{{ $t('crm.customer.create.personalHeader') }}</p>
            </b-col>
          </b-row>
        </div>
        <div slot="formBody">
          <b-row>
            <b-col cols="6">
              <FITTextInput field="userEmail" :label="$t('adm.agent.userEmail')" :placeholder="
            $t('adm.agent.userEmail')" v-model="form.userEmail" :width="columnWidth" :disabled="locked"></FITTextInput>
              <FITSelect :label="$t('adm.agent.marketingOptOut')" :placeholder="$t('adm.agent.marketingOptOut')" :options="yesNo" v-model="form.marketingOptOut" :width="columnWidth" :disabled="locked"></FITSelect>
            </b-col>
            <b-col cols="6">
              <FITSelect :label="$t('adm.agent.language')" :placeholder="$t('adm.agent.language')" :options="languages" v-model="form.language" :width="columnWidth" :disabled="locked"></FITSelect>
            </b-col>
          </b-row>
        </div>
      </FITFormCard>
      <FITFormCard v-if="form.position == 'MA'">
        <div slot="header">
          <b-row>
            <b-col cols="8">
              <p class="h5"><i class="fa fa-handshake mr-2"></i>{{ $t('adm.agent.managerOverrideRate') }}</p>
            </b-col>
          </b-row>
        </div>
        <div slot="formBody">
          <b-row>
            <b-col cols="6">
              <FITTextInput :label="$t('adm.agent.managerOverrideRate')+'(%)'" :width="columnWidth" :disabled="locked" v-model="form.commOverrideRatio"></FITTextInput>
            </b-col>
          </b-row>
        </div>
      </FITFormCard>
      <FITModal ref="agentSplitModal" reference="agentSplitModal" :title="(!providerDisabled)? $t('adm.agent.agentSplitModal.overrideAgentSplitRate'): $t('adm.agent.agentSplitModal.editAgentSplitRate')" @click="toggleEditSplitRate">
        <div slot="body">
          <span v-if="!providerDisabled">{{ $t('adm.agent.agentSplitModal.overrideAgentSplitRateBody') }}</span>
          <span v-if="providerDisabled">{{ $t('adm.agent.agentSplitModal.editAgentSplitRateBody') }}</span>
        </div>
      </FITModal>
      <FITFormCard>
        <div slot="header">
          <b-row>
            <b-col cols="8">
              <p class="h5"><i class="fa fa-handshake mr-2"></i>{{ $t('adm.agent.providerSplitRate') }}</p>
            </b-col>
          </b-row>
        </div>
        <div slot="formBody">
          <b-row class="my-3">
            <b-col cols="4" class="text-right">
              <b>{{ $t('adm.agent.provider') }}</b>
            </b-col>
            <b-col cols="3" class="text-center">
              <b>{{ $t('adm.agent.fyc') }}(%) <span class="text-danger">*</span></b>
            </b-col>
            <b-col cols="3" class="text-center">
              <b>{{ $t('adm.agent.commission') }}(%) <span class="text-danger">*</span></b>
            </b-col>
          </b-row>
          <b-row class="mb-2" align-v="center">
            <b-col cols="4" class="text-right">
              <span class="lead">{{ $t('adm.agent.defaultSplitRate.header') }}(%)</span>
            </b-col>
            <b-col cols="3" class="text-center">
              <FITTextInput field="splitRate" :placeholder="$t('adm.agent.fyc')" v-model="form.splitRate" :disabled="!providerDisabled"></FITTextInput>
            </b-col>
            <b-col cols="3" class="text-center">
              <FITTextInput  field="splitRate2"  :placeholder="$t('adm.agent.commission')" v-model="form.splitRate2" :disabled="!providerDisabled"></FITTextInput>
            </b-col>
          </b-row>
          <b-row class="mb-5" v-if="ID !== null">
            <b-col cols="6" offset="4">
              <b-button v-if="providerDisabled" class="w-100" variant="danger" @click="cancelOverride">
                <span class="fa fa-bars mr-2"></span>{{ $t('adm.agent.cancelSplitRate')}}
              </b-button>
              <b-button v-else class="w-100" variant="info" @click="showAgentSplitModal">
               <span class="fa fa-bars mr-2"></span>{{ $t('adm.agent.overrideSplitRate')}}
              </b-button>

  <!--             <b-button v-if="!providerDisabled" class="w-100" variant="info"   @click="showAgentSplitModal">
                 <span><span class="fa fa-bars mr-2"></span>{{ $t('adm.agent.overrideSplitRate')}}</span>
              </b-button> -->
<!--               <FITCheckbox v-else :label=" $t('adm.agent.overrideSplitRate')" v-model="splitRateOverideFlag"></FITCheckbox>
 -->
            </b-col>
          </b-row>
          <b-row class="py-2" align-v="center" v-if="ID !== null && !providerDisabled " v-for="splitRate in form.splitRates">
            <b-col cols="4" class="text-right">
              <span class="text-truncate lead">{{ splitRate.providerCode.trim() }}</span>
              <br />
              <span class="sub">{{ splitRate.providerChineseName }}</span>
            </b-col>
            <b-col cols="3" class="text-center">
              <b-form-input type="number" :placeholder="$t('crm.agent.create.fyc')" :disabled="locked" v-model="splitRate.splitRate"></b-form-input>
            </b-col>
            <b-col cols="3" class="text-center">
              <b-form-input type="number" :placeholder="$t('crm.agent.create.commission')" :disabled="locked" v-model="splitRate.splitRate2"></b-form-input>
            </b-col>
          </b-row>
        </div>
      </FITFormCard>
      <div class="text-right w-100">
        <FITButton class="min-width-button" size="md" :variant="(ID !== null) ? 'warning' : 'primary'" text="Submit" @click="validationCheck" :disabled="locked"></FITButton>
      </div>
    </div>
  </b-row>
</template>
<script>
import {
  FITTextInput,
  FITAutoSearch,
  FITCheckbox,
  FITSelect,
  FITDatePicker,
  FITTextarea,
  FITButton,
  FITFormCard,
  FITModal,
  FITValidationBus
} from '@/components';

import { mapState, mapGetters } from 'vuex'
import Cookies from 'js-cookie'

import Vue from 'vue';
import moment from 'moment';

export default {
  name: 'AgentCreate',
  components: {
    FITTextInput,
    FITAutoSearch,
    FITSelect,
    FITDatePicker,
    FITTextarea,
    FITButton,
    FITFormCard,
    FITModal,
    FITValidationBus,
    FITCheckbox
  },

  props: {
    ID: {
      type: Number,
      default: null
    },
    lead: {
      type: Object,
      default: null
    }
  },

  created() {

    this.$store.dispatch('getAllSelections', 'agent')
      .then((json) => {
        this.$store.commit({ type: 'Adm/setSelections', selections: json.data });

        if (this.ID) {
          Vue.set(this, 'providerDisabled', false);
          this.$store.dispatch('Adm/getAgentDetail', {
              ID: this.ID
            })
            .then((json) => {
              return new Promise((resolve, reject) => {
                if (json.data) {
                  Vue.set(this, 'locked', true);

                  let splitRates = json.data.splitRates;
                  let agentSplitRate = splitRates.map((item) => {
                    return {
                      providerCode: item.providerCode,
                      providerChineseName: item.providerChineseName,
                      agentID: this.ID,
                      providerID: item.providerID,
                      splitRate: this.convertFloatToPercent(item.splitRate),
                      splitRate2: this.convertFloatToPercent(item.splitRate2),
                    }
                  });
                  json.data['splitRates'] = agentSplitRate;
                  if (json.data['position'] === 'MA') {
                    json.data['commOverrideRatio'] = this.convertFloatToPercent(json.data.commOverrideRatio);
                  }
                  let cpdPoints = json.data['cpdPoints'];
                  Vue.set(this, 'cpdPoints', cpdPoints);
                  delete json.data['cpdPoints'];
                  Vue.set(this, 'form', json.data);
                  resolve(json.data);
                }
              })
            })
            .then((agent) => {
              let teamID = agent.agentTeam;
              let parentAgent = agent.parentAgent;

              if (teamID === -1) {
                Vue.set(this, 'isAgentTeamDisabled', true);
              } else {
                this.$store.dispatch('searchOption', {
                  dest: 'option',
                  searchInput: { type: 'team', ID: teamID }
                }).then((list) => {
                  if (list && list.length > 0) {
                    let agentTeam = list[0];
                    Vue.set(this, 'selectedAgentTeam', {
                      ID: agentTeam.ID,
                      teamCode: agentTeam.teamCode
                    })
                  }
                })
              }

              if (parentAgent === -1 || parentAgent == null) {
                Vue.set(this, 'isParentAgentDisabled', true);
              } else {
                this.$store.dispatch('searchOption', {
                  dest: 'option',
                  searchInput: { type: 'agent', ID: parentAgent }
                }).then((list) => {
                  if (list && list.length > 0) {
                    let parentAgent = list[0];
                    Vue.set(this, 'selectedParentAgent', {
                      agentCode: parentAgent.agentCode,
                      agentEnglishName: parentAgent.agentEnglishName,
                      agentChinsesName: parentAgent.agentChineseName
                    })
                  }
                })
              }
            });
        } else {
          Vue.set(this, 'providerDisabled', true);
          this.$store.dispatch('Provider/getProviderList')
            .then((json) => {
              Vue.set(this, 'providerList', json.data.list);
            })
            .catch((err) => {});
        }
      })
      .catch((err) => {
        console.error(err);
      })

    let validationType = 'create';
    if (this.ID) {
      validationType = 'edit';
    }

    this.$store.commit('Validation/validationReset');
    this.$store.dispatch('Validation/getValidationRule', `/agent/${validationType}`);
    this.$store.commit('Validation/setAlertMsg', { alertMsg: this.$t("validation.alertMsg.error") });


  },

  computed: {
    ...mapGetters('Adm', [
      'getTranslated'
    ]),
    ...mapState({
      'vuexFinalResult': state => state.Validation.validationFinalResult,
    }),
    positions() {

      return this.getTranslated(this.$i18n.locale, 'position');
    },

    contactTypes() {
      return this.getTranslated(this.$i18n.locale, 'contactType');
    },

    maritalStatus() {
      return this.getTranslated(this.$i18n.locale, 'maritalStatus');
    },

    educations() {
      return this.getTranslated(this.$i18n.locale, 'education');
    },

    idTypes() {
      return this.getTranslated(this.$i18n.locale, 'idType');
    },
  },
  watch: {
    'splitRateOverideFlag':{
       handler(newVal){
          if(newVal == true){
            return;
          }
          let splitRate = 0;
          let splitRate2 = 0;

          if(this.form.splitRate){
            splitRate = this.form.splitRate;
          }
          if(this.form.splitRate2){
            splitRate2 = this.form.splitRate2;
          }
          for (var i = 0; i < this.form.splitRates.length; i++) {
            this.form.splitRates[i].splitRate = splitRate;
            this.form.splitRates[i].splitRate2 = splitRate2;
          }
       }
    },
    'cpdForm': {
      deep: true,
      handler(param) {
        this.$store.dispatch('CPD/getAgentTrainingDetail', {
          agentID: this.ID,
          startDate: this.cpdForm.startDate,
          endDate: this.cpdForm.endDate
        }).then((result) => {
          Vue.set(this, 'cpdPoints', result.data);
        })
      }
    },
    selectedAgentTeam() {
      Vue.set(this.form, 'agentTeam', this.selectedAgentTeam.ID);
    },

    selectedParentAgent() {
      Vue.set(this.form, 'parentTeam', this.selectedParentAgent.ID);
    },

    vuexFinalResult(newData, oldData) {
      let result = newData;
      // console.log("Final Result: "+newData);
      if (result) {
        this.openConfirmModal();
        this.$store.commit('Validation/validationReset');
        // FITValidationBus.$emit('reset', true);
      }
    }


  },
  methods: {
    validationCheck() {
      this.$store.dispatch('Validation/validationCheckBeforeSubmit');
      return;
    },
    showAgentSplitModal() {
      this.$refs.agentSplitModal.openModal();
    },

    toggleEditSplitRate(success) {
      if (!success) {
        return;
      }
      Vue.set(this, 'providerDisabled', !this.providerDisabled);
      Vue.set(this, 'locked', !this.locked);
      // Vue.set(this, 'splitRateOverideFlag',true);
    },

    cancelOverride(){
      Vue.set(this, 'providerDisabled', !this.providerDisabled);
      Vue.set(this, 'locked', !this.locked);
      Vue.set(this.form, 'splitRate', "");
      Vue.set(this.form, 'splitRate2', "");

    },
    convertFloatToPercent(input) {
      var ans = (parseFloat(input) * 100).toFixed(2);
      return isNaN(ans) ? "" : ans;
    },

    convertPercentToFloat(input) {
      var ans = (input / 100).toFixed(2);
      return isNaN(ans) ? "" : ans;
    },

    updateLocked() {
      Vue.set(this, 'locked', !this.locked);
    },

    lockAgentTeam(evt) {
      this.isAgentTeamDisabled = !this.isAgentTeamDisabled;
      console.debug('Disabled', this.$refs.noAgentTeam.disabled);
      if (this.isAgentTeamDisabled) {
        Vue.set(this.form, 'agentTeam', null);
        Vue.set(this, 'selectedAgentTeam', { ID: -1 });
      }
    },

    lockParentAgent(evt) {
      Vue.set(this, 'isParentAgentDisabled', !this.isParentAgentDisabled);
      // this.isAgentTeamDisabled = !this.isAgentTeamDisabled;
      if (this.isParentAgentDisabled) {
        Vue.set(this.form, 'parentAgent', null);
        Vue.set(this, 'selectedParentAgent', { ID: -1 });
      }
    },

    didSelectLead(lead) {
      Vue.set(this.form, 'leadID', lead.ID);
      Vue.set(this.form, 'englishFirstname', lead.name);
      Vue.set(this.form, 'identityCardNo', lead.identityCardNo);
      Vue.set(this.form, 'telephoneMobile', lead.phoneNumber);
      Vue.set(this.form, 'gender', lead.gender);

      Vue.set(this, 'selectedLead', lead);
      this.$refs.leadList.hide();
    },

    openConfirmModal() {
      this.$refs.confirmation.openModal();
    },

    openLeadModal() {
      this.$refs.leadList.show();
    },

    confirm(confirmed) {
      this.createCustomer();
    },

    createCustomer() {
      let cpy = JSON.parse(JSON.stringify(this.form));
      if (cpy.position === 'MA') {
        cpy.commOverrideRatio = this.convertPercentToFloat(cpy.commOverrideRatio);
      }
      if (this.providerDisabled) {
        delete cpy['splitRates'];
        cpy['splitRate'] = this.convertPercentToFloat(cpy['splitRate']);
        cpy['splitRate2'] = this.convertPercentToFloat(cpy['splitRate2']);
      } else {
        delete cpy['splitRate'];
        delete cpy['splitRate2'];

        cpy['splitRates'] = cpy['splitRates'].map((item) => {
          item['splitRate'] = this.convertPercentToFloat(item['splitRate']);
          item['splitRate2'] = this.convertPercentToFloat(item['splitRate2']);
          return item;
        });
      }

      // Clone email
      cpy['email'] = cpy['userEmail'];

      if (this.form.ID) {
        console.debug('cpy', cpy);
        this.$store.dispatch('Adm/editAgent', cpy)
          .then((json) => {
            this.$router.replace({
              name: 'List Agent',
              params: { createSuccess: true }
            })
          })
          .catch((err) => {
            console.error(err);
          })
        return;
      }

      this.$store.dispatch('Adm/createAgent', cpy)
        .then((json) => {
          this.$router.replace({
            name: 'List Agent',
            params: { createSuccess: true }
          })
        })
        .catch((err) => {
          console.error(err);
        })
    }
  },

  data() {
    return {
      splitRateOverideFlag:null,
      role: '',
      providerList: [],
      providerDisabled: false,
      agentSplitRate: [],
      locked: false,
      isAgentTeamDisabled: false,
      isParentAgentDisabled: false,
      selectedParentAgent: { ID: -1 },
      selectedAgentTeam: { ID: -1 },
      selectedLead: this.lead,
      columnWidth: 9,
      genders: [{
        text: 'Male',
        value: 'M'
      }, {
        text: 'Female',
        value: 'F'
      }],

      yesNo: [{
        text: 'Yes',
        value: 'Y'
      }, {
        text: 'No',
        value: 'N'
      }],

      languages: [{
        text: 'English',
        value: 'english'
      }, {
        text: '繁體中文',
        value: 'zh_hk'
      }, {
        text: '简体中文',
        value: 'zh_cn'
      }],

      cpdForm: {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().add(1, 'year').format('YYYY-MM-DD'),
      },
      cpdPoints: {
        nonCorePoints: 0,
        corePoints: 0,
        totalPoints: 0
      },
      form: {
        customerCode: '',
        englishFirstname: '',
        englishLastname: '',
        chineseFirstname: '',
        chineseLastname: '',
        identityCardNo: '',
        dateOfBirth: '',
        maritalStatus: 'S',
        idType: 'HKID',
        education: 'P',
        contactType: 'R',
        // defaultAddress: '',
        occupation: '',
        nameOfEmployer: '',
        lengthOfServices: '',
        gender: 'F',
        telephoneMobile: '',
        telephoneHome: '',
        telephoneOffice: '',
        fax: '',
        email: '',
        chineseResidentialAddress: '',
        englishResidentialAddress: '',
        chineseCorrespondenceAddress: '',
        englishCorrespondenceAddress: '',
        chineseCompanyAddress: '',
        englishCompanyAddress: '',

        agentCode: '',
        agentTeam: null,
        parentAgent: null,
        position: 'AG',
        marketingOptOut: 'Y',
        language: 'english',
        userEmail: '',
        leaveDate: '',
        joinDate: '',

        cibLicense: 'N',
        mpfaLicense: 'N',

        ociLicenseLinkedLongTerm: 'N',
        ociLicenseTravel: 'N',
        ociLicenseLongTerm: 'N',
        ociLicenseGeneral: 'N',
        ociLicensePrinciples: 'N',

        sfcLicenseType10: 'N',
        sfcLicenseType9: 'N',
        sfcLicenseType8: 'N',
        sfcLicenseType7: 'N',
        sfcLicenseType6: 'N',
        sfcLicenseType5: 'N',
        sfcLicenseType4: 'N',
        sfcLicenseType3: 'N',
        sfcLicenseType2: 'N',
        sfcLicenseType1: 'N',

        splitRate: 0.0,
        splitRate2: 0.0,
      }
    }
  }
}

</script>
<style>
.min-width-button {
  min-width: 80px;
}

</style>



// WEBPACK FOOTER //
// src/Adm/Agent/AgentCreate.vue